import { BiExit, BiPhoneCall } from "react-icons/bi";
import { BsCart, BsLaptop } from "react-icons/bs";
import { FaHeadphones } from "react-icons/fa";
import { IoDocumentTextOutline } from "react-icons/io5";
import { MdHomeWork } from "react-icons/md";
import { PiPasswordBold } from "react-icons/pi";
import { Link } from "react-router-dom";

const links = [
  { url: "/", icon: MdHomeWork, title: "الرئيسية" },
  { url: "/laptops", icon: BsLaptop, title: "اللابتوبات" },
  { url: "/accessories", icon: FaHeadphones, title: "اكسسوارات" },
  { url: "/my-cart", icon: BsCart, title: "سلة المشتريات" },
  { url: "/cp/my-orders", icon: IoDocumentTextOutline, title: "حجوزاتي" },
  // { url: "/my-cart", icon: TbReportMoney, title: "دفعاتي المالية" },
  { url: "/cp/contact-us", icon: BiPhoneCall, title: "تواصل معنا" },
  {
    url: "/cp/change-password",
    icon: PiPasswordBold,
    title: "تغير كلمة المرور",
  },
  { url: "/logout", icon: BiExit, title: "تسجيل الخروج" },
];

export default function Cp() {
  return (
    <section className="py-12 px-4 font-[Tajawal]" dir="rtl">
      {/* قسم العنوان العلوي */}
      <div className="max-w-5xl mx-auto mb-10 text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white tracking-tight">
          العالمية للابتوب
        </h2>
        {/* خط زخرفي تحت العنوان */}
        <div className="flex justify-center mt-3">
          <div className="h-1 w-12 bg-mainLight rounded-full opacity-50" />
        </div>
        <p className="text-gray-500 dark:text-gray-400 mt-3 text-sm font-medium">
          لوحة التحكم - خدمات الوصول السريع
        </p>
      </div>

      {/* كروت التنقل */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-5xl mx-auto">
        {links.map((item, index) => (
          <QuickLinkCard key={index} item={item} />
        ))}
      </div>
    </section>
  );
}

function QuickLinkCard({ item }) {
  const Icon = item.icon;

  return (
    <Link
      to={item.url}
      className="group relative flex flex-col items-center justify-center gap-3 
                 rounded-[1.8rem] p-5 transition-all duration-500
                 bg-gray-200 dark:bg-white/5 
                 border border-gray-100 dark:border-white/10
                 hover:border-mainLight/50
                 hover:shadow-[0_15px_30px_rgba(0,0,0,0.05)] dark:hover:shadow-[0_15px_30px_rgba(var(--mainLight-rgb),0.05)]
                 hover:-translate-y-1 active:scale-95 overflow-hidden"
    >
      {/* الوهج الخلفي الخفيف */}
      <div className="absolute inset-0 bg-gradient-to-br from-mainLight/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />

      {/* حاوية الأيقونة - تم تصغيرها لـ 14 (56px) بدلاً من 20 */}
      <div
        className="relative flex items-center justify-center h-14 w-14 rounded-2xl 
                    bg-gray-100 dark:bg-white/5 
                    border border-gray-100 dark:border-white/10
                    transition-all duration-500 
                    group-hover:bg-mainLight group-hover:scale-105 group-hover:rotate-[5deg] shadow-sm"
      >
        {/* حجم الأيقونة تم تصغيره لـ 2xl */}
        <Icon className="text-2xl text-mainLight group-hover:text-white transition-colors duration-500" />
      </div>

      {/* العنوان - تم تصغير الخط لـ sm وبوزن عريض متناسق */}
      <div className="relative text-center">
        <span className="block text-sm font-bold text-gray-700 dark:text-gray-200 group-hover:text-mainLight transition-colors">
          {item.title}
        </span>
        {/* خط الزينة السفلي أصبح أنحف وأقصر */}
        <div className="w-0 h-[2px] bg-mainLight mx-auto mt-1 rounded-full transition-all duration-500 group-hover:w-8" />
      </div>

      {/* سهم الزاوية الصغير - تم تصغيره */}
      <div className="absolute top-4 left-4 opacity-0 group-hover:opacity-100 transition-all duration-500 -translate-x-2 group-hover:translate-x-0 text-[10px]">
        <div className="w-1.5 h-1.5 border-b-2 border-l-2 border-mainLight/50 -rotate-45" />
      </div>
    </Link>
  );
}
